import { DateInputCustomFormatPlaceholder } from '@progress/kendo-vue-dateinputs';

export const animationSetting: boolean = false;

export const datePickerFormatPlaceholder: DateInputCustomFormatPlaceholder = {
  year: 'yyyy',
  month: 'MM',
  day: 'dd',
};

export const dateTimePickerFormatPlaceholder: DateInputCustomFormatPlaceholder = {
  ...datePickerFormatPlaceholder,
  hour: 'HH',
  minute: 'mm',
};
